// NOTE: remember to update the UI-texts file on the drive, if you update this file */

const adminUiTexts = {
	loggedInAs: {
		da: 'Logget ind som',
		en: 'Logged in as',
	},
	
	textToSpeechPopup: {
		title: {
			da: 'Text to speech',
			en: 'Text to speech',
		},
		configuration: {
			da: 'Konfiguration',
			en: 'Configuration'
		},
		language: {
			da: 'Sprog',
			en: 'Language'
		},
		voice: {
			da: 'Stemme',
			en: 'Voice'
		},
		modules: {
			da: 'Moduler',
			en: 'Modules'
		},
		uploadBtn: {
			da: 'Upload tekster',
			en: 'Upload texts'
		}
	},

	refactorPlayerDataPopup: {
		title: {
			da: 'Refactor spillerdata',
			en: 'Refactor player data'
		},
		refactor: {
			da: 'Refactor',
			en: 'Refactor'
		}
	}
};

module.exports = {
	adminUiTexts
};